import type { App } from 'vue';
import FTable from './f-table.vue';
import FTableDetails from './f-table-details.vue';
import FTr from './f-tr.vue';
import FTh from './f-th.vue';
import FTd from './f-td.vue';
import FDetail from './f-detail.vue';

export declare interface Table {
  install: (app: App) => void;
}

export function useTable() : Table {
  return {
    install: (app: App) => {
      app.component('FTable', FTable);
      app.component('FTableDetails', FTableDetails);
      app.component('FTr', FTr);
      app.component('FTh', FTh);
      app.component('FTd', FTd);
      app.component('FDetail', FDetail);
    },
  };
}